module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-1-7b3223882a69fcd34a14f2041314e5d6.png";